/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Load_FailedInputs */

const en_us2_onboarding_load_failed = /** @type {(inputs: Onboarding_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your answers could not be loaded.`)
};

const pt_br2_onboarding_load_failed = /** @type {(inputs: Onboarding_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar suas respostas.`)
};

const es_419_onboarding_load_failed = /** @type {(inputs: Onboarding_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar tus respuestas.`)
};

const pt_pt2_onboarding_load_failed = /** @type {(inputs: Onboarding_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as tuas respostas.`)
};

const fr_fr2_onboarding_load_failed = /** @type {(inputs: Onboarding_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger tes réponses.`)
};

const de_de2_onboarding_load_failed = /** @type {(inputs: Onboarding_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Antworten konnten nicht geladen werden.`)
};

const it_it2_onboarding_load_failed = /** @type {(inputs: Onboarding_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare le tue risposte.`)
};

/**
* | output |
* | --- |
* | "Your answers could not be loaded." |
*
* @param {Onboarding_Load_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_load_failed = /** @type {((inputs?: Onboarding_Load_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Load_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_load_failed(inputs)
	if (locale === "es-419") return es_419_onboarding_load_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_load_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_load_failed(inputs)
	if (locale === "de-DE") return de_de2_onboarding_load_failed(inputs)
	if (locale === "it-IT") return it_it2_onboarding_load_failed(inputs)
	return en_us2_onboarding_load_failed(inputs)
});
export { onboarding_load_failed as "onboarding.load_failed" }